/**
 * VacantModeBadge — compact anomaly chip shown on AccountCard grid in P4 portfolio.
 * Promoted from inline text in home/page.tsx so B3 drill-in can reuse it.
 * Renders ONLY on the dark `card-dark` portfolio surface, so it uses the bright
 * brand-accent (gold) for AA on dark (the amber -text token is for light cards);
 * the amber-on-light warning-text step would drop to ~1.6:1 here (W7).
 * Atlas: B3, B1.
 */
import { AlertTriangle } from "lucide-react";

interface Props {
  label: string;
}

export function VacantModeBadge({ label }: Props) {
  return (
    <span className="inline-flex items-center gap-1 text-[10px] font-medium text-brand-accent bg-brand-accent/15 rounded px-1.5 py-0.5">
      <AlertTriangle size={10} aria-hidden />
      {label}
    </span>
  );
}
